import React from 'react';

// Target Icon (🎯)
export const TargetIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2" fill="none"/>
    <circle cx="12" cy="12" r="6" stroke={color} strokeWidth="2" fill="none"/>
    <circle cx="12" cy="12" r="2" fill={color}/>
  </svg>
);

// Clipboard Icon (📋)
export const ClipboardIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 2V4H6C5.45 4 5 4.45 5 5V19C5 19.55 5.45 20 6 20H18C18.55 20 19 19.55 19 19V5C19 4.45 18.55 4 18 4H16V2H14V4H10V2H8Z" fill={color}/>
    <rect x="8" y="1" width="8" height="3" rx="1" fill="white"/>
    <rect x="7" y="8" width="10" height="1.5" rx="0.75" fill="white"/>
    <rect x="7" y="11" width="7" height="1.5" rx="0.75" fill="white"/>
    <rect x="7" y="14" width="8" height="1.5" rx="0.75" fill="white"/>
  </svg>
);

// Search Icon (🔍)
export const SearchIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="11" cy="11" r="8" stroke={color} strokeWidth="2"/>
    <path d="m21 21-4.35-4.35" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// Chart Icon (📊)
export const ChartIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="16" width="4" height="5" rx="1" fill={color}/>
    <rect x="10" y="12" width="4" height="9" rx="1" fill={color}/>
    <rect x="17" y="8" width="4" height="13" rx="1" fill={color}/>
  </svg>
);

// Book Icon (📚)
export const BookIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 19.5C4 18.12 5.12 17 6.5 17H20V3H6.5C4.57 3 3 4.57 3 6.5V17.5C3 18.88 4.12 20 5.5 20H20V19.5H4Z" fill={color}/>
    <path d="M6 7H17V8.5H6V7Z" fill="white"/>
    <path d="M6 10H14V11.5H6V10Z" fill="white"/>
    <path d="M6 13H16V14.5H6V13Z" fill="white"/>
  </svg>
);

// Calculator Icon (🧮)
export const CalculatorIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="2" width="16" height="20" rx="2" fill={color}/>
    <rect x="6" y="4" width="12" height="3" rx="1" fill="white"/>
    <circle cx="8" cy="10" r="1" fill="white"/>
    <circle cx="12" cy="10" r="1" fill="white"/>
    <circle cx="16" cy="10" r="1" fill="white"/>
    <circle cx="8" cy="13" r="1" fill="white"/>
    <circle cx="12" cy="13" r="1" fill="white"/>
    <circle cx="16" cy="13" r="1" fill="white"/>
    <circle cx="8" cy="16" r="1" fill="white"/>
    <circle cx="12" cy="16" r="1" fill="white"/>
    <circle cx="16" cy="16" r="1" fill="white"/>
    <rect x="7.5" y="19" width="1" height="1" rx="0.5" fill="white"/>
    <rect x="12" y="18.5" width="4" height="2" rx="1" fill="white"/>
  </svg>
);

// Lightning Icon (⚡)
export const LightningIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 2L4.09 12.95C3.86 13.32 4.12 13.8 4.55 13.8H9L8 22L16.91 11.05C17.14 10.68 16.88 10.2 16.45 10.2H12L13 2Z" fill={color}/>
  </svg>
);

// Lightbulb Icon (💡)
export const LightbulbIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C8.14 2 5 5.14 5 9C5 11.38 6.19 13.47 8 14.74V17C8 17.55 8.45 18 9 18H15C15.55 18 16 17.55 16 17V14.74C17.81 13.47 19 11.38 19 9C19 5.14 15.86 2 12 2Z" fill={color}/>
    <rect x="9" y="19" width="6" height="1.5" rx="0.75" fill={color}/>
    <rect x="10" y="21" width="4" height="1.5" rx="0.75" fill={color}/>
    <circle cx="12" cy="9" r="2" fill="white"/>
  </svg>
);

// Sparkles Icon (✨)
export const SparklesIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L13.6 8.4L20 10L13.6 11.6L12 18L10.4 11.6L4 10L10.4 8.4L12 2Z" fill={color}/>
    <path d="M19 4L19.5 5.5L21 6L19.5 6.5L19 8L18.5 6.5L17 6L18.5 5.5L19 4Z" fill={color}/>
    <path d="M7 16L7.5 17.5L9 18L7.5 18.5L7 20L6.5 18.5L5 18L6.5 17.5L7 16Z" fill={color}/>
  </svg>
);

// Document Icon (📄)
export const DocumentIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 2H6C5.45 2 5 2.45 5 3V21C5 21.55 5.45 22 6 22H18C18.55 22 19 21.55 19 21V7L14 2Z" fill={color}/>
    <path d="M14 2V7H19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <rect x="7" y="10" width="10" height="1.5" rx="0.75" fill="white"/>
    <rect x="7" y="13" width="8" height="1.5" rx="0.75" fill="white"/>
    <rect x="7" y="16" width="9" height="1.5" rx="0.75" fill="white"/>
  </svg>
);

// PDF Icon (📕)
export const PdfIcon = ({ size = 24, color = '#DC2626' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 2H6C5.45 2 5 2.45 5 3V21C5 21.55 5.45 22 6 22H18C18.55 22 19 21.55 19 21V7L14 2Z" fill={color}/>
    <path d="M14 2V7H19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <text x="12" y="16" fontSize="8" fill="white" textAnchor="middle" fontWeight="bold">PDF</text>
  </svg>
);

// Graduation Cap Icon (🎓)
export const GraduationCapIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 3L1 9L12 15L21 10.09V17H23V9L12 3Z" fill={color}/>
    <path d="M5 13.18V17.18C5 17.97 8.58 20 12 20C15.42 20 19 17.97 19 17.18V13.18L12 17L5 13.18Z" fill={color}/>
  </svg>
);

// User Icon (👤)
export const UserIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L12 3L3 7V9C3 10.1 3.9 11 5 11V17C5 18.1 5.9 19 7 19H9C9.55 19 10 18.55 10 18V16H14V18C14 18.55 14.45 19 15 19H17C18.1 19 19 18.1 19 17V11C20.1 11 21 10.1 21 9Z" fill={color}/>
  </svg>
);

// Trend Up Icon (📈)
export const TrendUpIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 17L9 11L13 15L22 6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18 6L22 6L22 10" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Rocket Icon (🚀)
export const RocketIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C12 2 20 8 20 14C20 16.21 18.21 18 16 18H8C5.79 18 4 16.21 4 14C4 8 12 2 12 2Z" fill={color}/>
    <circle cx="12" cy="8" r="2" fill="white"/>
    <path d="M8 18C8 19.1 8.9 20 10 20H14C15.1 20 16 19.1 16 20" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M6 16L4 18M18 16L20 18" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// Home Icon (🏠)
export const HomeIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 12L12 3L21 12V20C21 20.55 20.55 21 20 21H4C3.45 21 3 20.55 3 20V12Z" fill={color}/>
    <path d="M9 21V12H15V21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="8" r="1" fill="white"/>
  </svg>
);

// Robot Icon (🤖)
export const RobotIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="6" y="8" width="12" height="10" rx="2" fill={color}/>
    <circle cx="10" cy="11" r="1" fill="white"/>
    <circle cx="14" cy="11" r="1" fill="white"/>
    <rect x="9" y="14" width="6" height="1.5" rx="0.75" fill="white"/>
    <circle cx="12" cy="5" r="1" fill={color}/>
    <rect x="11.5" y="6" width="1" height="2" fill={color}/>
    <rect x="4" y="10" width="2" height="1" rx="0.5" fill={color}/>
    <rect x="18" y="10" width="2" height="1" rx="0.5" fill={color}/>
    <circle cx="7" cy="20" r="1" fill={color}/>
    <circle cx="17" cy="20" r="1" fill={color}/>
  </svg>
);

// Palette Icon (🎨)
export const PaletteIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C13.3 2 14.6 2.3 15.8 2.9C18.8 4.4 21 7.5 21 11.1C21 12.4 20.6 13.7 19.9 14.8C19.2 15.9 18.1 16.7 16.9 17C16.5 17.1 16 17 15.7 16.7C15.4 16.4 15.3 15.9 15.4 15.5C15.5 15.1 15.8 14.8 16.2 14.8C16.6 14.8 17 14.4 17 14C17 13.4 16.6 13 16 13C15.4 13 15 13.4 15 14C15 15.1 14.1 16 13 16H12C6.5 16 2 11.5 2 6C2 3.2 4.2 1 7 1C8.1 1 9.1 1.4 9.9 2.1C10.6 1.4 11.8 2 12 2Z" fill={color}/>
    <circle cx="8.5" cy="6.5" r="1.5" fill="#FF6B6B"/>
    <circle cx="12" cy="5" r="1.5" fill="#4ECDC4"/>
    <circle cx="15.5" cy="6.5" r="1.5" fill="#45B7D1"/>
    <circle cx="16.5" cy="10" r="1.5" fill="#96CEB4"/>
    <circle cx="8" cy="10" r="1.5" fill="#FECA57"/>
  </svg>
);

// Pin Icon (📍)
export const PinIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 10C21 17 12 23 12 23S3 17 3 10C3 5.03 7.03 1 12 1S21 5.03 21 10Z" fill={color}/>
    <circle cx="12" cy="10" r="3" fill="white"/>
  </svg>
);

// Gear Icon (⚙️)
export const GearIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 15.5C14.21 15.5 16 13.71 16 11.5C16 9.29 14.21 7.5 12 7.5C9.79 7.5 8 9.29 8 11.5C8 13.71 9.79 15.5 12 15.5Z" fill="white"/>
    <path d="M19.14 12.94C19.18 12.64 19.2 12.33 19.2 12.02C19.2 11.71 19.18 11.4 19.14 11.1L21.16 9.48C21.34 9.34 21.39 9.07 21.28 8.87L19.36 5.55C19.24 5.33 18.99 5.26 18.77 5.33L16.38 6.29C15.88 5.91 15.35 5.59 14.76 5.35L14.4 2.81C14.36 2.57 14.16 2.4 13.92 2.4H10.08C9.84 2.4 9.64 2.57 9.6 2.81L9.24 5.35C8.65 5.59 8.12 5.92 7.62 6.29L5.23 5.33C5.01 5.25 4.76 5.33 4.64 5.55L2.72 8.87C2.61 9.08 2.66 9.34 2.84 9.48L4.86 11.1C4.82 11.4 4.8 11.72 4.8 12.02C4.8 12.32 4.82 12.64 4.86 12.94L2.84 14.56C2.66 14.7 2.61 14.97 2.72 15.17L4.64 18.49C4.76 18.71 5.01 18.78 5.23 18.71L7.62 17.75C8.12 18.13 8.65 18.45 9.24 18.69L9.6 21.23C9.64 21.47 9.84 21.64 10.08 21.64H13.92C14.16 21.64 14.36 21.47 14.4 21.23L14.76 18.69C15.35 18.45 15.88 18.12 16.38 17.75L18.77 18.71C18.99 18.79 19.24 18.71 19.36 18.49L21.28 15.17C21.39 14.96 21.34 14.7 21.16 14.56L19.14 12.94ZM12 15.6C9.14 15.6 6.8 13.26 6.8 10.4C6.8 7.54 9.14 5.2 12 5.2C14.86 5.2 17.2 7.54 17.2 10.4C17.2 13.26 14.86 15.6 12 15.6Z" fill={color}/>
    <circle cx="12" cy="12" r="3" fill="white"/>
  </svg>
);

// Computer Icon (💻)
export const ComputerIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="4" width="20" height="12" rx="2" fill={color}/>
    <rect x="4" y="6" width="16" height="8" rx="1" fill="white"/>
    <rect x="8" y="18" width="8" height="2" rx="1" fill={color}/>
    <rect x="6" y="20" width="12" height="1" rx="0.5" fill={color}/>
  </svg>
);

// Link Icon (🔗)
export const LinkIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 13C10.42 13.46 10.96 13.8 11.53 14C12.1 14.2 12.74 14.2 13.31 14C13.88 13.8 14.42 13.46 14.84 13L17.66 10.17C18.44 9.39 18.44 8.13 17.66 7.34C16.88 6.56 15.62 6.56 14.83 7.34L13.41 8.76" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14 11C13.58 10.54 13.04 10.2 12.47 10C11.9 9.8 11.26 9.8 10.69 10C10.12 10.2 9.58 10.54 9.16 11L6.34 13.83C5.56 14.61 5.56 15.87 6.34 16.66C7.12 17.44 8.38 17.44 9.17 16.66L10.59 15.24" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Phone Icon (📱)
export const PhoneIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="5" y="2" width="14" height="20" rx="2" fill={color}/>
    <rect x="6.5" y="4" width="11" height="15" rx="1" fill="white"/>
    <circle cx="12" cy="20.5" r="1" fill="white"/>
  </svg>
);

// Edit Icon (📝)
export const EditIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 4H4C3.45 4 3 4.45 3 5V19C3 19.55 3.45 20 4 20H18C18.55 20 19 19.55 19 19V12" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18.5 2.5C18.89 2.11 19.52 2.11 19.91 2.5L21.5 4.09C21.89 4.48 21.89 5.11 21.5 5.5L12 15L8 16L9 12L18.5 2.5Z" fill={color}/>
  </svg>
);

// Lock Icon (🔒)
export const LockIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="5" y="11" width="14" height="10" rx="2" fill={color}/>
    <path d="M7 11V7C7 4.24 9.24 2 12 2C14.76 2 17 4.24 17 7V11" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <circle cx="12" cy="16" r="1" fill="white"/>
  </svg>
);

// Bell Icon (🔔)
export const BellIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 8A6 6 0 0 0 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z" fill={color}/>
    <path d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6981 21.5547 10.4458 21.3031 10.27 21" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Download Icon (⬇️)
export const DownloadIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7 10L12 15L17 10" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 15V3" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Upload Icon (⬆️)
export const UploadIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M17 8L12 3L7 8" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 3V15" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Trash Icon (🗑️)
export const TrashIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 6H5H21" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Eye Icon (👁️)
export const EyeIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 12S5 4 12 4S23 12 23 12S19 20 12 20S1 12 1 12Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="12" r="3" stroke={color} strokeWidth="2"/>
  </svg>
);

// Eye Off Icon (👁️‍🗨️)
export const EyeOffIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.68192 3.96914 7.65663 6.06 6.06M9.9 4.24C10.5883 4.0789 11.2931 3.99836 12 4C19 4 23 12 23 12C22.393 13.1356 21.6691 14.2048 20.84 15.19M14.12 14.12C13.8454 14.4148 13.5141 14.6512 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1747 15.0074 10.8019 14.8565C10.4291 14.7056 10.0947 14.4811 9.80385 14.1962C9.51297 13.9113 9.28849 13.5769 9.13756 13.2041C8.98664 12.8313 8.91251 12.4307 8.91959 12.0279C8.92668 11.6251 9.01488 11.2278 9.17884 10.8598C9.3428 10.4919 9.5792 10.1606 9.874 9.88599" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M1 1L23 23" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Check Icon (✅)
export const CheckIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 6L9 17L4 12" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// X Icon (❌)
export const XIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18M6 6L18 18" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// LogOut Icon (🚪)
export const LogOutIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="16,17 21,12 16,7" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="21" y1="12" x2="9" y2="12" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Mail Icon (📧)
export const MailIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="22,6 12,13 2,6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Arrow Left Icon (⬅️)
export const ArrowLeftIcon = ({ size = 24, color = '#007AFF' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 12H5" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 19L5 12L12 5" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
); 